import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhoSection() {
  return <section className="bg-[#141210]" style={{
    paddingTop: 'var(--space-section)',
    paddingBottom: 'var(--space-section)',
    paddingLeft: 'var(--pad-x)',
    paddingRight: 'var(--pad-x)'
  }} data-id="element-58">
      <div className="max-w-4xl mx-auto" data-id="element-59">
        <h2 className="fluid-3xl font-bold text-white text-center mb-12 font-serif" data-id="element-60">
          ¿Es esto para ti?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-61">
          {/* Es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#0D0D0D] p-6 sm:p-8 rounded-xl border-t-4 border-[#2E7D32]" data-id="element-62">
            <h3 className="fluid-xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-63">
              <CheckCircle2 className="text-[#2E7D32] w-5 h-5 shrink-0" data-id="element-64" />
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-65">
              {['La ruptura es reciente (0–30 días)', 'Te cuesta parar el impulso de escribir o mirar redes', 'Quieres volver a ti sin humillarte'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#F5F0EB]/80 fluid-base" data-id="element-66">
                  <span className="text-[#2E7D32] mt-1 shrink-0" data-id="element-67">✓</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#0D0D0D] p-6 sm:p-8 rounded-xl border-t-4 border-[#9A948C]" data-id="element-68">
            <h3 className="fluid-xl font-bold text-[#9A948C] mb-6 flex items-center gap-2" data-id="element-69">
              <XCircle className="text-[#9A948C] w-5 h-5 shrink-0" data-id="element-70" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-71">
              {['Estás en una situación de violencia o peligro (tu prioridad es seguridad y apoyo profesional)', 'Necesitas asesoría legal', 'Buscas que te prometa "recuperarlo"'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#9A948C] fluid-base" data-id="element-72">
                  <span className="text-[#9A948C] mt-1 shrink-0" data-id="element-73">✕</span>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}